import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImpersonationRepository } from '../impersonation/impersonation.repository';
import { UserSettingsRepository } from '../settings/user-settings.repository';
import { UserRepository } from '../user/user.repository';
import { DefaultImpersonationRepository } from './default-impersonation.repository';
import { DefaultUserRepository } from './default-user.repository';
import { DefaultUserSettingsRepository } from './default-user-settings.repository';

@NgModule({
  imports: [CommonModule],
  providers: [
    { provide: UserRepository, useClass: DefaultUserRepository },
    { provide: UserSettingsRepository, useClass: DefaultUserSettingsRepository },
    { provide: ImpersonationRepository, useClass: DefaultImpersonationRepository }
  ]
})
export class DefaultUserProviderModule {}
